const login = {
   // seems to be deprecated >> see public/conf/login-messages.js
   useKeycloak: true,
   maintenance: {
    show: false,
    html: '<p>Liebe Teilnehmende:</p><p>aufgrund von Security-Einstellungen auf unserem wbh-OnlineCampus kann es aktuell vermehrt dazu kommen, dass der Login nicht wie gewohnt funktioniert. Damit Sie schnell und unkompliziert den Online Campus erreichen können, löschen Sie bitte einmal Ihren Browser-Cache und stellen Sie sicher, dass Sie den Campus über die URL <a style="text-decoration: none;" href="https://www.wb-online-campus.de/#/">www.wb-online-campus.de</a><span> aufrufen. Dann sollte der Login reibungslos funktionieren.</p><p>Bitte entschuldigen Sie die Umstände,</p><p>Ihr wbh-OnlineCampus-Team</p>'
   },
   footer:[{
      label: 'Wilhelm Büchner Hochschule',
      uri: 'https://www.wb-fernstudium.de',
      target: '_blank'
    },{
      label: 'Impressum',
      uri: 'https://www.wb-fernstudium.de/impressum.html',
      target: '_blank'
    },{
      label: 'Datenschutz',
      uri: 'https://www.wb-online-campus.de/c/datenschutz',
      target: '_blank'
    }]
}
export default { login }
